import '../../App.css';
import React, { useContext } from "react";
import { IoIosWarning } from "react-icons/io";
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ApiContext } from '../../context/ApiContext';

function ModalExcluirCargo({currentPage}) {

    const { setModalExcluirCargo, ExcluirCargo, CargoAtualKey } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    return (
        <div className="modal-novo">
            <div className="modal-interno-delete">
                <div className="modal-content-delete">
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '20px', padding: '16px' }} className='border-bottom'>
                        <div>
                            <IoIosWarning style={{ color: '#FACC15', marginRight: '5px' }} /> Excluir cargo
                        </div>
                        <button className='btn-fechar' onClick={() => setModalExcluirCargo(false)}>
                            <FaTimes />
                        </button>
                    </div>
                    <div style={{ padding: '16px' }} className='border-bottom'>
                        Tem certeza que deseja excluir esse cargo?
                    </div>
                    <div className="content-buttons">
                        <button type="submit" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalExcluirCargo(false)}>Cancelar</button>
                        <button type="submit" className="btn-dash btn-criar" style={btnCriar} onClick={() => ExcluirCargo(CargoAtualKey, currentPage)}>Excluir</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalExcluirCargo